import React from 'react';
import { Route, Switch } from 'react-router';
import { NewPassiveIncomeRules } from '../../pages/new-passive-income-rules/NewPassiveIncomeRules';
import GenericLogo from '../../common/images/generic-logo-1.jpeg';

export class BrandedClientShareLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Switch>
                <Route path="/:lang(en|fr)/passive-investment-income" render={(props) => <NewPassiveIncomeRules {...props} company='Generic Co.' phone='604-888-9999' email='john@genericco.ca' logo={GenericLogo} />} />
            </Switch>
        );
    }

}